export const STORE = 'JAVELIN_STORE';
export const STORE_ALL = `${STORE}/ALL`;
export const STORE_SELECT = `${STORE}/SELECT`;
export const STORE_GET_BY_ID = `${STORE}/GET_BY_ID`;
export const STORE_INSIGHTS = `${STORE}/INSIGHTS`;
export const STORE_TERMINAL_SHIPPING_METHODS = `${STORE}/TERMINAL_SHIPPING_METHODS`;
